import { render, staticRenderFns } from "./img-viewer.vue?vue&type=template&id=73333c23&scoped=true&"
import script from "./img-viewer.vue?vue&type=script&lang=js&"
export * from "./img-viewer.vue?vue&type=script&lang=js&"
import style0 from "./img-viewer.vue?vue&type=style&index=0&id=73333c23&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73333c23",
  null
  
)

export default component.exports